import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from '../components/FadeIn';
const sections = [{
  number: '01',
  heading: 'Acceptance of Terms',
  paragraphs: ['By accessing or using this website, you agree to be bound by these Terms of Service and by any applicable laws and regulations. If you do not agree to these Terms, you should not use the website.', 'These Terms apply to all visitors, readers, subscribers, contributors, and other users of the site.']
}, {
  number: '02',
  heading: 'Use of the Website',
  paragraphs: ['You may use this website only for lawful purposes and in accordance with these Terms. You agree not to:'],
  list: ['Use the site in violation of any law or regulation', 'Interfere with or disrupt the operation or security of the site', 'Attempt unauthorized access to systems, accounts, or data', 'Copy, scrape, reproduce, or republish site content in a misleading, unlawful, or unauthorized manner', 'Use the site to harass, defame, threaten, or harm others', 'Submit false, deceptive, or malicious information through forms or communications'],
  afterList: 'We reserve the right to restrict, suspend, or terminate access where misuse is detected or reasonably suspected.'
}, {
  number: '03',
  heading: 'Intellectual Property',
  paragraphs: ['Unless otherwise stated, the content of this website, including text, graphics, branding, logos, layout, original concepts, and site materials, is owned by or licensed to Cognarchism and is protected by applicable intellectual property laws.', 'You may view, download, or print content for personal, informational, and non-commercial use only, unless separate written permission is granted. No ownership rights are transferred by such use.', 'Unauthorized reproduction, modification, republication, distribution, or commercial exploitation of site materials is prohibited.']
}, {
  number: '04',
  heading: 'Informational Content Only',
  paragraphs: ['The content published on this site is provided for informational, educational, editorial, or philosophical purposes only, unless explicitly stated otherwise. Nothing on this website constitutes legal advice, professional advice, investment advice, medical advice, or a binding governmental or institutional directive.', 'Users are responsible for evaluating information independently and obtaining professional advice where appropriate.']
}, {
  number: '05',
  heading: 'User Submissions',
  paragraphs: ['If you submit messages, inquiries, feedback, suggestions, or other materials through the site, you represent that you have the right to submit them and that they do not violate any law or third-party rights.', 'Unless otherwise agreed in writing, you grant Cognarchism a non-exclusive right to review, store, and use such submissions for the purpose of responding, improving the website, developing materials, or operating related services.', 'We are not obligated to keep submissions confidential unless expressly agreed.']
}, {
  number: '06',
  heading: 'Accounts and Communications',
  paragraphs: ['If any part of the website allows subscriptions, mailing lists, gated materials, or account features, you agree to provide accurate information and to keep such information current.', 'You are responsible for maintaining the confidentiality of your account credentials, if applicable, and for activities occurring under your account.', 'We may send administrative, operational, or informational communications related to your use of the site or your subscription preferences.']
}, {
  number: '07',
  heading: 'Third-Party Services and Links',
  paragraphs: ['This website may reference, embed, or link to third-party sites, platforms, tools, or services. We do not control and are not responsible for the availability, content, practices, or policies of such third parties.', 'Your use of third-party services is governed by their own terms and policies, not these Terms of Service.']
}, {
  number: '08',
  heading: 'Disclaimers',
  paragraphs: ['This website and its content are provided on an "as is" and "as available" basis. To the fullest extent permitted by law, Cognarchism disclaims warranties of any kind, whether express or implied, including warranties of accuracy, reliability, availability, merchantability, fitness for a particular purpose, and non-infringement.', 'We do not guarantee that the site will be uninterrupted, error-free, secure, or free of harmful components, or that all content will remain current at all times.']
}, {
  number: '09',
  heading: 'Limitation of Liability',
  paragraphs: ['To the fullest extent permitted by law, Cognarchism and its operators, affiliates, contributors, and service providers shall not be liable for any indirect, incidental, special, consequential, punitive, or similar damages arising out of or related to your access to or use of the website.', 'Where liability cannot be excluded by law, it shall be limited to the minimum extent permitted by applicable law.']
}, {
  number: '10',
  heading: 'Indemnification',
  paragraphs: ['You agree to indemnify and hold harmless Cognarchism and its operators, affiliates, contributors, and service providers from and against claims, liabilities, damages, losses, and expenses arising from:'],
  list: ['Your use of the website', 'Your violation of these Terms', 'Your violation of applicable law', 'Your infringement of any third-party rights']
}, {
  number: '11',
  heading: 'Termination',
  paragraphs: ['We reserve the right, at our discretion, to suspend, restrict, or terminate access to the website or its services at any time and without prior notice where necessary to protect the site, enforce these Terms, comply with legal requirements, or address misuse.', 'Provisions of these Terms that by their nature should survive termination shall remain in effect after termination.']
}, {
  number: '12',
  heading: 'Governing Law',
  paragraphs: ['These Terms of Service shall be governed by and construed in accordance with the laws of [Insert Jurisdiction], without regard to conflict-of-law principles.', 'Any disputes arising out of or relating to these Terms or the use of the website shall be subject to the courts or dispute resolution processes of that jurisdiction, unless otherwise required by applicable law.']
}, {
  number: '13',
  heading: 'Changes to These Terms',
  paragraphs: ['We may revise these Terms of Service from time to time. Any updated version will be posted on this page with a revised effective date.', 'Your continued use of the site after revised Terms are posted constitutes acceptance of those revised Terms.']
}, {
  number: '14',
  heading: 'Contact',
  paragraphs: ['For questions about these Terms of Service, contact:'],
  contactBlock: true
}];
export function TermsOfService() {
  return <article data-id="element-442">
      {/* Hero */}
      <section className="pt-32 pb-20 md:pt-40 md:pb-28 bg-cognarch-white border-b border-cognarch-border" data-id="element-443">
        <div className="max-w-3xl mx-auto px-6" data-id="element-444">
          <FadeIn delay={0.1} direction="down" data-id="element-445">
            <p className="uppercase tracking-[0.25em] text-xs font-medium text-cognarch-gray mb-8" data-id="element-446">
              Legal
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-447">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-medium leading-[1.1] tracking-tight text-cognarch-black mb-8" data-id="element-448">
              Terms of Service
            </h1>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-449">
            <p className="text-lg md:text-xl text-cognarch-gray leading-relaxed mb-6 max-w-2xl" data-id="element-450">
              These Terms of Service govern your access to and use of the
              Cognarchism website, its content, and any related communications,
              materials, or services made available through the site.
            </p>
            <p className="text-sm text-cognarch-gray/70" data-id="element-451">
              Effective Date: March 28, 2026
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Body Sections */}
      {sections.map((section, index) => <section key={section.number} className={`py-20 md:py-28 border-b border-cognarch-border ${index % 2 === 1 ? 'bg-cognarch-offwhite' : 'bg-cognarch-white'}`} data-id="element-452">
          <div className="max-w-3xl mx-auto px-6" data-id="element-453">
            <FadeIn data-id="element-454">
              <div className="flex items-baseline gap-6 mb-8" data-id="element-455">
                <span className="text-cognarch-border font-serif text-4xl md:text-5xl leading-none select-none" data-id="element-456">
                  {section.number}
                </span>
                <h2 className="text-2xl md:text-4xl font-serif text-cognarch-charcoal leading-tight" data-id="element-457">
                  {section.heading}
                </h2>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-458">
              <div className="space-y-6" data-id="element-459">
                {section.paragraphs.map((paragraph, pIndex) => <p key={pIndex} className="text-cognarch-gray leading-[1.8] text-base md:text-lg" data-id="element-460">
                    {paragraph}
                  </p>)}

                {section.list && <ul className="space-y-3 py-4 pl-1" data-id="element-461">
                    {section.list.map((item, lIndex) => <li key={lIndex} className="flex items-start gap-3 text-cognarch-gray text-base" data-id="element-462">
                        <span className="text-cognarch-charcoal/30 text-xs mt-1.5" data-id="element-463">
                          ◆
                        </span>
                        {item}
                      </li>)}
                  </ul>}

                {section.afterList && <p className="text-cognarch-gray leading-[1.8] text-base md:text-lg" data-id="element-464">
                    {section.afterList}
                  </p>}

                {section.contactBlock && <div className="border-t border-cognarch-border mt-8 pt-8 space-y-2" data-id="element-465">
                    <p className="text-cognarch-charcoal font-serif text-lg" data-id="element-466">
                      Cognarchism
                    </p>
                    <p className="text-cognarch-gray text-base" data-id="element-467">
                      [Insert Contact Email]
                    </p>
                    <p className="text-cognarch-gray text-base" data-id="element-468">
                      [Insert Mailing Address or Business Address if applicable]
                    </p>
                  </div>}
              </div>
            </FadeIn>
          </div>
        </section>)}

      {/* Closing Statement Block */}
      <section className="py-24 md:py-32 bg-cognarch-black text-white" data-id="element-469">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-470">
          <FadeIn data-id="element-471">
            <div className="w-16 h-px bg-white/20 mx-auto mb-12" data-id="element-472" />
            <p className="text-xl md:text-2xl font-serif leading-relaxed text-white/80 mb-12 text-balance" data-id="element-473">
              These Terms exist to preserve lawful use, protect the integrity of
              the site, and define the relationship between Cognarchism and its
              users.
            </p>
            <div className="w-16 h-px bg-white/20 mx-auto mb-12" data-id="element-474" />
            <p className="uppercase tracking-[0.25em] text-sm text-white/50 font-medium" data-id="element-475">
              Clear terms. Lawful use. Protected integrity.
            </p>
          </FadeIn>
        </div>
      </section>
    </article>;
}